import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { fetchTenants } from '../lib/api';

interface Tenant {
  id: string;
  name: string;
}

interface TenantState {
  tenants: Tenant[];
  selectedTenantId: string;
  setSelectedTenantId: (id: string) => void;
}

const TenantContext = createContext<TenantState | undefined>(undefined);

const STORAGE_KEY = 'secuguard_selected_tenant';

export function TenantProvider({ children }: { children: React.ReactNode }) {
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [selectedTenantId, setSelectedTenantIdState] = useState<string>(() => {
    return localStorage.getItem(STORAGE_KEY) || '';
  });

  useEffect(() => {
    fetchTenants()
      .then((data: Tenant[]) => setTenants(data || []))
      .catch(console.error);
  }, []);

  const setSelectedTenantId = useCallback((id: string) => {
    setSelectedTenantIdState(id);
    if (id) {
      localStorage.setItem(STORAGE_KEY, id);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, []);

  return (
    <TenantContext.Provider value={{ tenants, selectedTenantId, setSelectedTenantId }}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant() {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error('useTenant must be used within TenantProvider');
  return ctx;
}
